jQuery(document).ready(function ($) {
  //Menu JS

  $(".testimonial-section").fadeIn();
  $(".hamburger").click(function () {
    $("body").addClass("js-mobile-menu-open");
    $("li.menu-item-has-children a span").removeClass("arrowopen");
    $(".hamburger--menu").animate(
      {
        opacity: 1,
        width: "toggle",
      },
      50,
      function () {
        // Animation complete.
      }
    );

    if ($(this).hasClass("spin")) {
      $("body").removeClass("js-mobile-menu-open");
      $(".sub-menu").removeClass("subMenu");
    }

    $(this).toggleClass("spin");
  });
  $(".mobile-menu .menu-item-has-children > a").append(
    "<span class='arrow'></span>"
  );

  $(".mobile-menu .menu-item-has-children > a span.arrow").click(function (e) {
    e.preventDefault();

    $(this)
      .parents("a")
      .next(".sub-menu")
      .stop(true, true)
      .toggleClass("subMenu");

    $(this).toggleClass("arrowopen");

    let currentParent = $(this).parents("li");

    // Remove Submenu class from of any other li that's not the current li clicked

    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("ul")
      .removeClass("subMenu");

    // Remove arrowopen class from any other li (Not submenu li) that's not the currently clicked parent menu
    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("a span.arrow")
      .removeClass("arrowopen");
  });

  $(window).resize(function () {
    var winwidth = $(window).width();
    if (winwidth > 1160) {
      $(".hamburger--menu").stop(true, true).slideUp();
      $(".hamburger").removeClass("spin");
      $("body").removeClass("js-mobile-menu-open");
    }
  });

  // Get the dimensions and position of the Nav Menu

  function subMenuPosition(Nav) {
    var NavWidth = Nav.width();
    var NavHeight = Nav.height();
    var NavOffset = Nav.offset();
    var NavLeft = NavOffset.left;
    var NavTop = NavOffset.top;

    // Get the dimensions of the viewport
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();

    // Check if the Nav is going off the screen
    var isNavGoingOffScreen =
      NavLeft < 0 ||
      NavLeft + NavWidth > viewportWidth ||
      NavTop < 0 ||
      NavTop + NavHeight > viewportHeight;

    return isNavGoingOffScreen;
  }

  var subMenu = $("li.menu-item-has-children");
  $(subMenu).hover(function () {
    var Nav = $($(this).find(".sub-menu"));
    var isNavGoingOffScreen = subMenuPosition(Nav);

    if (isNavGoingOffScreen) {
      Nav.css("right", "0px");
    }
  });

  var subMenu = $(
    "li.menu-item-has-children .sub-menu li.menu-item-has-children"
  );
  $(subMenu).hover(function () {
    var Nav = $($(this).find(".sub-menu"));
    var isNavGoingOffScreen = subMenuPosition(Nav);
    if (isNavGoingOffScreen) {
      Nav.css("right", "100%");
      Nav.css("left", "unset");
    }
  });

  //Vide Background JS
  function scaleToFill() {
    $("video.video-background").each(function (videoTag) {
      var $video = $(videoTag),
        videoRatio = videoTag.videoWidth / videoTag.videoHeight,
        tagRatio = $video.width() / $video.height(),
        val;

      if (videoRatio < tagRatio) {
        val = (tagRatio / videoRatio) * 1.02;
      } else if (tagRatio < videoRatio) {
        val = (videoRatio / tagRatio) * 1.02;
      }

      $video.css("transform", "scale(" + val + "," + val + ")");
    });
  }

  $(function () {
    scaleToFill();

    $(".video-background").on("loadeddata", scaleToFill);

    $(window).resize(function () {
      scaleToFill();
    });
  });

  $(".testimonial-slide").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var maxHeight = Math.max.apply(
        null,
        $(".testimonial-item.slick-active")
          .map(function () {
            return $(this).height();
          })
          .get()
      );

      $(this).animate({ height: maxHeight + 30 }, 500);
      console.log(maxHeight);
    }
  );

  $(".testimonial-slide").slick({
    autoplay: true,
    autoplaySpeed: 10000,
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
      responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ],
    prevArrow:
      '<span class="slick-prev"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.017 1.995c5.517 0 9.997 4.48 9.997 9.998s-4.48 9.998-9.997 9.998c-5.518 0-9.998-4.48-9.998-9.998s4.48-9.998 9.998-9.998zm0 1.5c-4.69 0-8.498 3.808-8.498 8.498s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.498-8.497-8.498zm-1.528 4.715s-1.502 1.505-3.255 3.259c-.147.147-.22.339-.22.531s.073.383.22.53c1.753 1.754 3.254 3.258 3.254 3.258.145.145.335.217.526.217.192-.001.384-.074.531-.221.292-.293.294-.766.003-1.057l-1.977-1.977h6.693c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.693l1.978-1.979c.29-.289.287-.762-.006-1.054-.147-.147-.339-.221-.53-.222-.19 0-.38.071-.524.215z" fill-rule="nonzero"/></svg></span>',
    nextArrow:
      '<span class="slick-next"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.012 1.995c-5.518 0-9.998 4.48-9.998 9.998s4.48 9.998 9.998 9.998 9.997-4.48 9.997-9.998-4.479-9.998-9.997-9.998zm0 1.5c4.69 0 8.497 3.808 8.497 8.498s-3.807 8.498-8.497 8.498-8.498-3.808-8.498-8.498 3.808-8.498 8.498-8.498zm1.528 4.715s1.502 1.505 3.255 3.259c.146.147.219.339.219.531s-.073.383-.219.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.336.217-.527.217-.191-.001-.383-.074-.53-.221-.293-.293-.295-.766-.004-1.057l1.978-1.977h-6.694c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.694l-1.979-1.979c-.289-.289-.286-.762.006-1.054.147-.147.339-.221.531-.222.19 0 .38.071.524.215z" fill-rule="nonzero"/></svg></span>',
      
  });

  $(".section-slide").slick({
    autoplay: true,
    autoplaySpeed: 10000,
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    arrows: false,
    adaptiveHeight: true,
  });



    $(".ot-carousel").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      arrows: true,
      adaptiveHeight: true,
      prevArrow:
        '<span class="slick-prev"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.017 1.995c5.517 0 9.997 4.48 9.997 9.998s-4.48 9.998-9.997 9.998c-5.518 0-9.998-4.48-9.998-9.998s4.48-9.998 9.998-9.998zm0 1.5c-4.69 0-8.498 3.808-8.498 8.498s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.498-8.497-8.498zm-1.528 4.715s-1.502 1.505-3.255 3.259c-.147.147-.22.339-.22.531s.073.383.22.53c1.753 1.754 3.254 3.258 3.254 3.258.145.145.335.217.526.217.192-.001.384-.074.531-.221.292-.293.294-.766.003-1.057l-1.977-1.977h6.693c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.693l1.978-1.979c.29-.289.287-.762-.006-1.054-.147-.147-.339-.221-.53-.222-.19 0-.38.071-.524.215z" fill-rule="nonzero"/></svg></span>',
      nextArrow:
        '<span class="slick-next"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.012 1.995c-5.518 0-9.998 4.48-9.998 9.998s4.48 9.998 9.998 9.998 9.997-4.48 9.997-9.998-4.479-9.998-9.997-9.998zm0 1.5c4.69 0 8.497 3.808 8.497 8.498s-3.807 8.498-8.497 8.498-8.498-3.808-8.498-8.498 3.808-8.498 8.498-8.498zm1.528 4.715s1.502 1.505 3.255 3.259c.146.147.219.339.219.531s-.073.383-.219.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.336.217-.527.217-.191-.001-.383-.074-.53-.221-.293-.293-.295-.766-.004-1.057l1.978-1.977h-6.694c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.694l-1.979-1.979c-.289-.289-.286-.762.006-1.054.147-.147.339-.221.531-.222.19 0 .38.071.524.215z" fill-rule="nonzero"/></svg></span>',
    });




    $(".icon-box-carousel").slick({
      autoplay: false,
      autoplaySpeed: 10000,
      dots: false,
      infinite: true,
      speed: 500,
      cssEase: "linear",
      arrows: true,
      adaptiveHeight: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      prevArrow:
        '<span class="slick-prev"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.017 1.995c5.517 0 9.997 4.48 9.997 9.998s-4.48 9.998-9.997 9.998c-5.518 0-9.998-4.48-9.998-9.998s4.48-9.998 9.998-9.998zm0 1.5c-4.69 0-8.498 3.808-8.498 8.498s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.498-8.497-8.498zm-1.528 4.715s-1.502 1.505-3.255 3.259c-.147.147-.22.339-.22.531s.073.383.22.53c1.753 1.754 3.254 3.258 3.254 3.258.145.145.335.217.526.217.192-.001.384-.074.531-.221.292-.293.294-.766.003-1.057l-1.977-1.977h6.693c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.693l1.978-1.979c.29-.289.287-.762-.006-1.054-.147-.147-.339-.221-.53-.222-.19 0-.38.071-.524.215z" fill-rule="nonzero"/></svg></span>',
      nextArrow:
        '<span class="slick-next"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.012 1.995c-5.518 0-9.998 4.48-9.998 9.998s4.48 9.998 9.998 9.998 9.997-4.48 9.997-9.998-4.479-9.998-9.997-9.998zm0 1.5c4.69 0 8.497 3.808 8.497 8.498s-3.807 8.498-8.497 8.498-8.498-3.808-8.498-8.498 3.808-8.498 8.498-8.498zm1.528 4.715s1.502 1.505 3.255 3.259c.146.147.219.339.219.531s-.073.383-.219.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.336.217-.527.217-.191-.001-.383-.074-.53-.221-.293-.293-.295-.766-.004-1.057l1.978-1.977h-6.694c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.694l-1.979-1.979c-.289-.289-.286-.762.006-1.054.147-.147.339-.221.531-.222.19 0 .38.071.524.215z" fill-rule="nonzero"/></svg></span>',
    });





  // Team members JS

  $(".team--carousel").slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow:
      '<span class="slick-prev"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.017 1.995c5.517 0 9.997 4.48 9.997 9.998s-4.48 9.998-9.997 9.998c-5.518 0-9.998-4.48-9.998-9.998s4.48-9.998 9.998-9.998zm0 1.5c-4.69 0-8.498 3.808-8.498 8.498s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.498-8.497-8.498zm-1.528 4.715s-1.502 1.505-3.255 3.259c-.147.147-.22.339-.22.531s.073.383.22.53c1.753 1.754 3.254 3.258 3.254 3.258.145.145.335.217.526.217.192-.001.384-.074.531-.221.292-.293.294-.766.003-1.057l-1.977-1.977h6.693c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.693l1.978-1.979c.29-.289.287-.762-.006-1.054-.147-.147-.339-.221-.53-.222-.19 0-.38.071-.524.215z" fill-rule="nonzero"/></svg></span>',
    nextArrow:
      '<span class="slick-next"><svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.012 1.995c-5.518 0-9.998 4.48-9.998 9.998s4.48 9.998 9.998 9.998 9.997-4.48 9.997-9.998-4.479-9.998-9.997-9.998zm0 1.5c4.69 0 8.497 3.808 8.497 8.498s-3.807 8.498-8.497 8.498-8.498-3.808-8.498-8.498 3.808-8.498 8.498-8.498zm1.528 4.715s1.502 1.505 3.255 3.259c.146.147.219.339.219.531s-.073.383-.219.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.336.217-.527.217-.191-.001-.383-.074-.53-.221-.293-.293-.295-.766-.004-1.057l1.978-1.977h-6.694c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.694l-1.979-1.979c-.289-.289-.286-.762.006-1.054.147-.147.339-.221.531-.222.19 0 .38.071.524.215z" fill-rule="nonzero"/></svg></span>',
  });

  $(".team-grid-absolute").click(function () {
    $(".close").show();
    $(this).next(".modal").fadeIn();
    $(".modal-content").show().animate({
      right: "0",
    });
    $("body").css("overflow", "hidden");
    $(".team--carousel").slick("refresh");
  });

  $(".close").click(function () {
    $(".modal").fadeOut(function () {});
    $(".modal-content").animate(
      {
        right: "-100%",
      },
      () => {
        $(this).hide();
      }
    );
    $("body").css("overflow", "visible");
    //  $('.carousel').carousel('dispose');
    // $('#fb-root').show();
  });

  $(window).click(function (e) {
    if ($(e.target).hasClass("modal")) {
      $(".modal").fadeOut(function () {
        $(".close").css("display", "none");
        $("body").css("overflow", "visible");
        //  $('.carousel').carousel('dispose');
        //  $('#fb-root').show();
      });

      $(".modal-content").animate(
        {
          right: "-100%",
        },
        () => {
          $(this).hide();
        }
      );
    }
  });

  // FAQ Js
  $(".faq--listing div.question").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("open");
    $(this).siblings().stop(true, true).slideToggle();
    $(".faq--listing div.question")
      .not(this)
      .removeClass("open")
      .siblings()
      .slideUp();
    $(".faq--listing div.faq--icon")
      .not(this)
      .html('<span class="close"></span>');
    if ($(this).hasClass("open")) {
      $(this).children(".faq--icon").html('<span class="open"></span>');
    } else {
      $(this).children(".faq--icon").html('<span class="close"></span>');
    }
  });



// Form PopUP JS


  $(".popup-btn").click(function (e) {
    e.preventDefault();
    var popid = this.id;
    console.log(popid);
    $("div#" + popid).css("visibility","visible").css("opacity","1");
    $(".close").css("display", "block");
    $("body").addClass("js-mobile-menu-open").css("overflow", "hidden");
  });

  $(".close").click(function () {
    $(".ot_form_popup").css("visibility", "hidden").css("opacity","1");
      $(".close").css("display", "none");
      $("body").removeClass("js-mobile-menu-open");
  });

// Video JS

  $(".mt-video .play").click(function () {
    if ($(this).parent().prev().get(0).paused) {
      $(this).parent().prev().get(0).play();
      $(this).parent().prev().removeClass("blurEffect");
      $(this).parent().prev().attr("controls", "controls");
      $(this).hide();
    } else {
      $(this).parent().prev().get(0).pause();
      $(this).fadeIn();
      $(this).parent().prev().removeAttr("controls");
    }
  });

  $(".mt-video .video").on("ended", function () {
    $(this).addClass("blurEffect");
    $(this).removeAttr("controls");
    $(this).parent().find(".play").fadeIn();
  });

  $(document).on("click", "#mobile-nav-toggle", function () {
    if ($(".navbar-collapse").hasClass("add-bg")) {
      $(".custom-nav").removeClass("add-bg");
    } else {
      setTimeout(function () {
        if (
          $(".navbar-collapse").hasClass("show") &&
          !$(".navbar-collapse").hasClass("add-bg")
        ) {
          $(".custom-nav").addClass("add-bg");
        } else {
          $(".custom-nav").removeClass("add-bg");
        }
      }, 350);
    }
  });


  

});
